import { render, staticRenderFns } from "./JobsOffersSaved.vue?vue&type=template&id=734a5f50&scoped=true"
import script from "./JobsOffersSaved.vue?vue&type=script&lang=ts"
export * from "./JobsOffersSaved.vue?vue&type=script&lang=ts"
import style0 from "./JobsOffersSaved.vue?vue&type=style&index=0&id=734a5f50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734a5f50",
  null
  
)

export default component.exports